module.exports = __webpack_public_path__ + "img/6.d94e076b.jpg";